"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _backbone = _interopRequireDefault(require("backbone"));

var _underscore = _interopRequireDefault(require("underscore"));

var _config = _interopRequireDefault(require("config"));

var _RegistrationFieldsCollection = _interopRequireDefault(require("./RegistrationFieldsCollection"));

var _RegistrationField = _interopRequireDefault(require("./RegistrationField"));

var _backboneRelational = _interopRequireDefault(require("backbone-relational"));

var _backboneValidation = _interopRequireDefault(require("backbone-validation"));

var _FeatureToggleUtils = _interopRequireDefault(require("../utils/FeatureToggleUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEPARATOR_ENUM = 'SEPARATOR';

var SubmissionForm = _backbone.default.RelationalModel.extend({
  relations: [{
    type: _backbone.default.HasMany,
    key: 'included',
    relatedModel: _RegistrationField.default,
    collectionType: _RegistrationFieldsCollection.default,
    parse: true
  }, {
    type: _backbone.default.HasMany,
    key: 'entities',
    relatedModel: _RegistrationField.default,
    collectionType: _RegistrationFieldsCollection.default,
    parse: true
  }],
  url: function url() {
    if (_FeatureToggleUtils.default.isFeatureEnabled('hideBizzaboTermsCheckboxAndAutoAgree')) {
      this.set('legalAgreement', true);
    }

    return _config.default.baseUrl + '/events/' + this.get('eventId') + '/forms/web';
  },
  isAllModelValid: function isAllModelValid(validate) {
    var values = this.get('formType') == 'registration' ? this.get('entities') : this.get('included');
    var isEntityValid = true;

    if (values) {
      values.each(function (entity) {
        if (entity.get('entityType') === 'url') {
          var localValues = entity.get('localValues');
          var isEmptyUrlValue = _underscore.default.isArray(localValues) && localValues.length === 1 && localValues[0] === null;
          isEntityValid = isEmptyUrlValue ? true : entity.isValid(validate) && isEntityValid;
        } else {
          isEntityValid = entity.isValid(validate) && isEntityValid;
        }
      });
    }

    return this.isValid(validate) && isEntityValid;
  },
  toJSON: function toJSON(options) {
    var toJSON = _backbone.default.RelationalModel.prototype.toJSON.call(this);

    var forSave = options && _underscore.default.has(options, 'emulateJSON');

    if (forSave) {
      toJSON = this.transformFieldsIds(toJSON);
    }

    return toJSON;
  },
  copyFromForm: function copyFromForm(form) {
    var newEntites = form.get('entities');
    this.get('entities').each(function (entity) {
      var result = _underscore.default.find(newEntites.models, function (newEntity) {
        var newId = newEntity.get('id');
        newId = newId.substr(0, newId.indexOf('_'));
        var oldId = entity.get('id');
        oldId = oldId.substr(0, oldId.indexOf('_'));
        return oldId == newId;
      });

      if (result) {
        result.get('localValues') && entity.set('localValues', result.get('localValues'));
      }
    });
  },
  transformFieldsIds: function transformFieldsIds(data) {
    data.included && _underscore.default.each(data.included, function (field) {
      field.id = field.id.substr(0, field.id.indexOf('_'));
    });
    return data;
  },
  clearForm: function clearForm() {
    var formFields = this.get('included');

    if (formFields) {
      formFields.each(function (field) {
        field.set('localValues', '', {
          validate: false
        });
      });
    }
  },
  validation: {
    'legalAgreement': [{
      fn: function fn(value) {
        if (!value && !_FeatureToggleUtils.default.isFeatureEnabled('hideBizzaboTermsCheckboxAndAutoAgree')) {
          return 'Please read and accept terms before proceeding';
        }
      }
    }],
    'additionalTermsConsent': [{
      fn: function fn(value, attr, computedState) {
        if (!value && computedState.additionalTermsMandatory) {
          return 'Please read and accept terms before proceeding';
        }
      }
    }]
  }
});

var _default = SubmissionForm;
exports.default = _default;